module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_8004.2bd553a5.png";